import React from 'react';
import { Helmet } from 'react-helmet-async';
import SITE_ENTITIES from '../config/siteEntities.json';

/**
 * The sitewide entity graph (#280): one Organization (#organization) and one
 * SoftwareApplication (#software) on every route. Rendered once, in App, so no
 * layout can drop it or add a second copy.
 *
 * app/schema_generator.py reads the same file and adds both blocks to the
 * served HTML whenever react-snap dropped Helmet's head (and on template-served
 * routes). It tags them data-rh="true", so this Helmet replaces them at
 * hydration and there is still one of each afterwards.
 */
const SiteEntities = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(SITE_ENTITIES.organization)}</script>
    <script type="application/ld+json">{JSON.stringify(SITE_ENTITIES.software)}</script>
  </Helmet>
);

export default SiteEntities;
